import React from 'react'
import SvgIcon, { iconNames } from '../../svgIcon/SvgIcon'
import styles from './massiveResponseOk.module.css'
import { labels } from './../../../labels'

interface IMassiveResponseOkProps {
    onClose: () => void
    isError: boolean
}

export default function MassiveResponseOk({
    onClose,
    isError,
}: IMassiveResponseOkProps) {
    const showErrorText = () => {
        return (
            <div>
                {labels.responseErrorPart1} <br />
                {labels.responseErrorPart2} <br />
                {labels.responseErrorPart3} <br />
            </div>
        )
    }
    return (
        <div className={styles.container} style={{ width: 350 }}>
            <div className={styles.icon}>
                <SvgIcon
                    iconName={isError ? iconNames.error : iconNames.responseOK}
                />
            </div>
            <p className="Body1-16" style={{ marginTop: 10, marginBottom: 10 }}>
                {isError ? showErrorText() : labels.responseOk}
            </p>
            <div className={styles.buttons}>
                <button
                    onClick={onClose}
                    className={
                        isError ? styles.buttonError : styles.buttonContinue
                    }
                >
                    {labels.continue}
                </button>
            </div>
        </div>
    )
}
